import React, { useState, useCallback, memo } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import { trackEvent } from '@surfline/web-common';
import ChatIcon from 'components/Icons/ChatIcon';
import CamFeedbackFormWrapper from 'components/CamFeedbackForm/CamFeedbackFormWrapper';
import { getParsedCameraTitle } from 'utils/camera';

import { SmartRewindPlaylistBlock } from 'utils/rewinds/playlistBlocks.types';
import { Camera } from 'types/camera';
import { SpotDetails } from 'types/spot';
import { RefState } from 'hooks/useRefState';
import styles from './CamFeedbackModal.module.scss';
import { Player } from '../CamPlayerKbygRewinds/usePlayerState/usePlayerState';

interface CamFeedbackModalProps {
  camera: Camera;
  spot: SpotDetails;
  currentPlayer: Player;
  currentTimestampRef?: RefState<Date | undefined>;
  currentPlaylist?: SmartRewindPlaylistBlock;
  timezone: string;
  isWavePool: boolean;
}

const CamFeedbackModal: React.FC<CamFeedbackModalProps> = ({
  camera,
  spot,
  currentPlayer,
  currentTimestampRef,
  currentPlaylist,
  timezone,
  isWavePool,
}) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  const handleFeedbackChatIconClick = useCallback(() => {
    setIsFeedbackModalOpen(true);

    trackEvent('Button Clicked', {
      buttonText: 'Camera Feedback',
      spotId: spot._id,
      spotName: spot.name,
      cameraId: camera._id,
      cameraName: getParsedCameraTitle(camera.title),
      pageName: 'Spot Report',
      uiElement: 'Camera Player Menu',
    });
  }, [spot, camera]);

  return (
    <>
      <IconButton
        onClick={handleFeedbackChatIconClick}
        className={styles.camFeedbackButton}
        disabled={false}
        data-testid="cam-feedback-modal-button"
        aria-label="Open camera feedback modal"
      >
        <ChatIcon />
      </IconButton>
      <Modal open={isFeedbackModalOpen} className={styles.modal}>
        <Box className={styles.modalContent}>
          <CamFeedbackFormWrapper
            setIsModalOpen={setIsFeedbackModalOpen}
            cameraId={camera._id}
            cameraName={getParsedCameraTitle(camera.title)}
            currentTimestamp={currentPlayer === Player.REWIND ? currentTimestampRef : undefined}
            rewindList={currentPlaylist?.rewinds}
            spotId={spot._id}
            spotName={spot.name}
            spotTimezone={timezone}
            isWavePool={isWavePool}
          />
        </Box>
      </Modal>
    </>
  );
};

export default memo(CamFeedbackModal);
